// src/components/Footer.jsx (o dove lo tieni tu)
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../css/footer.css";

export default function Footer() {
  const year = new Date().getFullYear();

  const socials = [
    {
      label: "Instagram",
      aria: "Instagram",
      url: "https://www.instagram.com/lylescoaching?igsh=MWRhNHJubDJveG56Zw==",
    },
    { label: "YouTube", aria: "YouTube", url: null },
    { label: "LinkedIn", aria: "LinkedIn", url: null },
  ];

  return (
    <footer className="site-footer">
      <Container className="footer-container py-4">
        <Row className="text-center text-md-start">
          {/* Brand / Info */}
          <Col md={3} className="mb-4 mb-md-0">
            <h5 className="mb-2">Lyle Joubert</h5>
            <p className="m-0">Pesaro IT • Remote coaching worldwide</p>
            <p className="m-0">
              Email: <p className="link-plain">joubertlyle62@gmail.com</p>
            </p>
            <p className="m-0">VAT: IT 01234567890</p>
          </Col>

          {/* Links */}
          <Col md={3} className="mb-4 mb-md-0">
            <h5 className="mb-2">About</h5>
            <ul className="list-unstyled footer-links">
              <li>
                <a href="/#consultation">Coaching</a>
              </li>
              <li>
                <Link to="/workouts">Programs</Link>
              </li>
              <li>
                <span className="text-muted" style={{ cursor: "not-allowed" }}>
                  Testimonials (coming soon)
                </span>
              </li>
              <li>
                <span className="text-muted" style={{ cursor: "not-allowed" }}>
                  FAQ (coming soon)
                </span>
              </li>
            </ul>
          </Col>

          {/* Legal */}
          <Col md={3} className="mb-4 mb-md-0">
            <h5 className="mb-2">Support</h5>
            <ul className="list-unstyled footer-links">
              <li>
                <Link to="/terms">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/privacy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/cookies">Cookie Policy</Link>
              </li>
            </ul>
          </Col>

          {/* Social */}
          <Col md={3}>
            <h5 className="mb-2">Follow</h5>
            <nav className="footer-social" aria-label="Social media">
              {socials.map((s) =>
                s.url ? (
                  <a
                    key={s.label}
                    href={s.url}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={s.aria}
                  >
                    {s.label}
                  </a>
                ) : (
                  <span
                    key={s.label}
                    className="text-muted"
                    aria-label={`${s.aria} (coming soon)`}
                    style={{ cursor: "not-allowed" }}
                  >
                    {s.label}
                  </span>
                )
              )}
            </nav>
          </Col>
        </Row>

        <hr className="footer-sep my-4" />

        <Row>
          <Col className="text-center">
            <p className="mb-1">© {year} Lyle Joubert — Fitness & Coaching </p>
            <p className="m-0 small text-dim">
              design and developing : Giulio Fardella
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
